import React from 'react';
import loadingicon from './bouncy.gif';

const LoadingIcon = () => (
  <img src={loadingicon} alt="A bouncing Greens logo" height="150" width="150" />
);

export default LoadingIcon;
